import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
// import Logo from "../../../assets/icons/Logo.svg";
import Logo from "../../../assets/image/logo2.png";
import any from "../../../assets/headerpage-icon/villa.svg";
import house from "../../../assets/headerpage-icon/villa.svg";
import Townhouse from "../../../assets/headerpage-icon/townhouse.svg";
import Condo from "../../../assets/headerpage-icon/condo.svg";
import Villa from "../../../assets/headerpage-icon/villa.svg";
import Luxury from "../../../assets/headerpage-icon/villa.svg";
import MultiFamily from "../../../assets/headerpage-icon/multi-family.svg";
import Land from "../../../assets/headerpage-icon/land.svg";
import Waterfront from "../../../assets/headerpage-icon/waterfront.svg";
import Pool from "../../../assets/headerpage-icon/pool.svg";
import Equestrian from "../../../assets/headerpage-icon/equestrian.svg";
import Golfcourse from "../../../assets/headerpage-icon/Golf Hole Ball.svg";
import forms from "../../../assets/headerpage-icon/forms.svg";
import debounce from "lodash.debounce";
import phoneIcon from "../../../assets/headerpage-icon/phone-icon.svg";
import msgIcon from "../../../assets/headerpage-icon/msg-icon.svg";
import { currentuser } from "../../../util/currentuser";
import { Filterlist, Filters } from "../ProductDetails";
import {
  dynamicListing,
  getFilterListData,
  propertyListing,
} from "../../../api/idx";
import { handdleAscending, handdleDescending } from "../../../util/sorting";
import Filter from "../Components/Filter";
import { NewProductDetails } from "./NewProductDetails";
import { useDispatch, useSelector } from "react-redux";
import {
  login_success,
  logout,
  setsearchbaraddress,
} from "../../../state/actions";
import { CListGroup } from "@coreui/react";
import { isMobile } from "react-native-web";
import { useSearchParams } from "../../../hooks/useSearchParams";
import { debug } from "console";
import {
  changePage,
  changePropertyType,
  changeSpecialFeature,
  changeSubPropertyType,
  changeToAny,
  onToggleFilter,
  resetPageNo,
} from "../../../state/filterActions";
import mapIcon from "../../../assets/image/Map_icon.png";
import hamburgerIcon from "../../../assets/image/hamburger-icon.png";
import Navigation from "../Components/UI/Navigation";
import CardList from "../Components/UI/CardList";

import SwitchTab from "../Components/UI/SwtichTabs";
import { ListRendering } from "../Components/UI/ListRendering";
import path from "path";

type Props = {
  filter?: any;

  buySellActive?: boolean;
};

export const NewNavbar: React.FC<Props> = (props) => {
  const { } = props;
  const [loggedin, setLoggedIn] = useState(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [oddata, setoddata] = useState<any>();
  const history = useHistory();
  const location = useLocation();
  const [scrollPosition, setScrollPosition] = useState(false);
  const [toggleNav, settoggleNav] = useState(false);
  const [address, setAddress] = useState("");

  const [loadingForProType, setLoadingForProType] = useState<boolean>(false);
  useEffect(() => {
    localStorage.setItem("selectedValue", "new_listing");
    const updatePosition = () => {
      if (window.pageYOffset > 100) {
        setScrollPosition(true);
      } else {
        setScrollPosition(false);
      }
    };
    window.addEventListener("scroll", updatePosition);
    updatePosition();
    return () => window.removeEventListener("scroll", updatePosition);
  }, []);
  useEffect(() => {
    async function fetchCurrentUser() {
      let user: any = localStorage.getItem("user");
      let user_id = JSON.parse(user);
      if (user_id) {
        setLoggedIn(true);
      } else {
        setLoggedIn(false);
      }
    }
    fetchCurrentUser();
  }, []);

  const handlelogin = (e: any) => {
    e.preventDefault();
    history.push("/login");
  };

  const handlePopup = () => {
    settoggleNav(!toggleNav);
  };

  const handleClickOutside = (event: any) => {
    if (event.target.closest(".profile-dropdown") === null) {
      settoggleNav(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    dispatch(logout());
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////////

  let user_id = currentuser();

  const [propertylisting, setPropertyListing] = useState<any>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [toggle, setToggle] = useState<Boolean>(false);
  const [propertyTypeVal, setPropertyTypeVal] = useState<any>(null);
  const [filter, setFilter] = useState<Filters>({
    city: null,
    country: null, //@ts-ignore
    countyOrParish: null,
    zip: null,
    stateOrProvince: null,
    number_of_beds: null,
    number_of_baths: null,
    yearbuilt: null,
    highschool: null,
    elementaryschool: null,
    garageyn: null,
    horseyn: null,
    garagespaces: null,
    subdivisionname: null,
    highschooldistrict: null,
    waterfrontfeatures: [],
    waterfront: null,
    riverfront: null,
    lakefront: null,
    pool_In_Ground: null,
    pool_Above_Ground: null,
    pool_Access: null,
    horse_Permitted: null,
    out_Building: null,
    golf_Course: null,
    searchdata: null,
    lotFeatures: null,
    yearbuiltmin: null,
    yearbuiltmax: null,
    garagespacesmin: null,
    garagespacesmax: null,
    propertytype: null,
    propertysubtype: null,
    newconstructionyn: null,
    fireplacemin: null,
    fireplacemax: null,
    squarefeetmin: null,
    squarefeetmax: null,
    pricemin: null,
    pricemax: null,
    userid: user_id ? user_id?.id : null,
    pageSize: 20,
    pageNo: currentPage,
    luxury: null,
    streetNumber: null,
    lotrange: null,
    new_listing: true,
    lowest_price: null,
    highest_price: null,
    year_built: null,
    open_house_date: null,
    recently_reduced: null,
    largest_sqft: null,
    lot_size: null,
    cityAddres: null,
  });

  const [filterlist, setFilterList] = useState<Filterlist>({
    city: [],
    country: [], //@ts-ignore
    countyOrParish: [],
    highschool: [],
    highschooldistrict: [],
    subdivisionname: [],
    zip: [],
    yearbuilt: [],
    fireplaces: [],
    garagespace: [],
    propertysubtype: [],
    cityandstate: [],
    searchdata: [],
    squarefeet: [],
    price: [],
    lotrange: [],
  });
  const [count, setCount] = useState<any>();
  const [pagescountstartend, setPagesCountStartend] = useState({
    start: 1,
    end: 20,
  });

  useEffect(() => {
    async function anonymous() {
      let data = await getFilterListData();

      const sortedcity = data?.city.sort();
      const sortedcountry = data?.country.sort();
      const sortedcountyOrParish = data?.countyOrParish?.sort();
      const sortedfireplaces = data?.fireplaces.sort((a: any, b: any) => a - b);
      const sortedgaragespace = data?.garagespace.sort(
        (a: any, b: any) => a - b
      );
      const sortedprice = data?.price.sort((a: any, b: any) => a - b);
      const sortedsquarefeet = data?.squarefeet.sort((a: any, b: any) => a - b);
      const sortedzip = data?.zip.sort((a: any, b: any) => a - b);
      const sortedyearbuilt = data?.yearbuilt.sort();
      const sortedhighschool = data?.highschool.sort();
      const sortedhighschooldistrict = data?.highschooldistrict.sort();
      const sortedsubdivisionname = data?.subdivisionname.sort();
      const sortedpropertysubtype = data?.propertysubtype.sort();
      const sortedcityandstate = data?.cityandstate.sort();
      const lotrange = data?.lotrange;
      setFilterList({
        city: sortedcity,
        country: sortedcountry, //@ts-ignore
        countyOrParish: sortedcountyOrParish,
        highschool: sortedhighschool,
        highschooldistrict: sortedhighschooldistrict,
        subdivisionname: sortedsubdivisionname,
        zip: sortedzip,
        yearbuilt: sortedyearbuilt,
        fireplaces: sortedfireplaces,
        garagespace: sortedgaragespace,
        propertysubtype: sortedpropertysubtype,
        cityandstate: sortedcityandstate,
        searchdata: data.searchdata,
        squarefeet: sortedsquarefeet,
        price: sortedprice,
        lotrange: lotrange,
      });
    }
    anonymous();
  }, []);

  let typesofproperty = {
    city: null,
    country: null,
    countyOrParish: null,
    zip: null,
    stateOrProvince: null,
    number_of_beds: null,
    number_of_baths: null,
    yearbuilt: null,
    highschool: null,
    elementaryschool: null,
    garageyn: null,
    horseyn: null,
    garagespaces: null,
    subdivisionname: null,
    highschooldistrict: null,
    waterfront: null,
    riverfront: null,
    lakefront: null,
    pool_In_Ground: null,
    pool_Above_Ground: null,
    pool_Access: null,
    horse_Permitted: null,
    out_Building: null,
    golf_Course: null,
    searchdata: null,
    yearbuiltmin: null,
    yearbuiltmax: null,
    garagespacesmin: null,
    garagespacesmax: null,
    propertytype: null,
    propertysubtype: null,
    newconstructionyn: null,
    fireplacemin: null,
    fireplacemax: null,
    squarefeetmin: null,
    squarefeetmax: null,
    pricemin: null,
    pricemax: null,
    lotFeatures: null,
    specialfeature: null,
    userid: null,
    pageSize: 20,
    pageNo: currentPage,
    luxury: null,
    streetNumber: null,
    waterfrontfeatures: [],
    lotrange: null,
    new_listing: true,
  };
  const [newtype, setNewtype] = useState("");
  const [check, setcheck] = useState({});
  // const check = useRef(null)

  const hasRun = useRef(false);
  const [time, settimes] = useState(false);

  const handlePropertyTypeChange = async (type: string) => { };

  //@ts-ignore
  const val = useSelector((state) => state?.new?.signset);

  const handleSorting = (type: string) => {
    if (type === "ascending") {
      let sorted_data = handdleDescending(propertylisting);
      setPropertyListing(sorted_data);
    }
    if (type === "descending") {
      let sorted_data = handdleAscending(propertylisting);
      setPropertyListing(sorted_data);
    }
  };
  const [selectedSort, setSelectedSort] = useState("new_listing");
  const nextPage = () => {
    // setCurrentPage((prevPage) => prevPage + 1);
    dispatch(changePage("inc"));
    setPagesCountStartend({
      start: pagescountstartend.start + 20,
      end:
        oddata < pagescountstartend.end + 20
          ? oddata
          : pagescountstartend.end + 20,
    });
    window.scrollTo({
      top: 0,

      behavior: "smooth",
    });
    setSelectedSort(selectedSort);
  };

  const prevPage = () => {
    // setCurrentPage((prevPage) => prevPage - 1);
    dispatch(changePage("dec"));
    setPagesCountStartend({
      start: pagescountstartend.start - 20,
      end: pagescountstartend.end - 20,
    });
    window.scrollTo({
      top: 0,

      behavior: "smooth",
    });
    setSelectedSort(selectedSort);
  };

  const dispatch = useDispatch();
  const gotoleads = () => {
    let data: any = localStorage.getItem("logindata");
    let res = JSON.parse(data);
    let user = JSON.parse(atob(res?.jwtToken.split(".")[1]));
    // let JWTtoken = atob(data?.jwtToken.split('.')[1])
    // const user = JSON.parse(JWTtoken);
    dispatch(
      login_success({
        token: res?.jwtToken,
        user: {
          ...user,
          permissions: user.permissions.split(","),
        },
      })
    );
    // navigate_to('/leads');
  };

  const handlePageDonw = () => {
    if (
      location.pathname == "/homepage" ||
      location.pathname == "/homepage?address="
    ) {
      //@ts-ignore
      props?.contRef?.current.scrollIntoView({ behavior: "smooth" }); //@ts-ignore
    } else {
      history.push("/homepage"); //@ts-ignore
      localStorage.setItem("contactScroll", true);
    }
  };

  //26/07/2024s
  // const handlePropertyTypeChange = (type: string) => {
  // setNewtype(type)
  // getfilter(type)
  // };

  const [number, setNumber] = useState(4028800202);
  const textUsBtn = () => {
    const userAgent = navigator.userAgent;
    if (
      /(android|ipad|iphone|ipod|ipod touch|blackberry|playbook|silk|kindle|webos|tizen|sony|symbian)/i.test(
        userAgent
      )
    ) {
      const url = `sms:${number}`;
      window.open(url, "_self");
    } else {
      const emailUrl = `mailto:karie@milford.com`;
    }
  };
  // const [cityDetailsData, setCityDetailsData] = useState({});
  const cityDetailsData = useRef();

  const [cityAddres, setCityAddress] = useState("");

  const handleOnSearch = async (cityName: any) => {
    let res = await dynamicListing(cityName);
    localStorage.setItem("onaddressbar", cityName); //@ts-ignore
    cityDetailsData.current = res?.data?.data; //@ts-ignore
    dispatch({ type: "cityDetailsData", payload: res?.data?.data });
  };

  const modalFilter = useSelector(
    (store: any) => store?.filterReducer?.modalFilter
  );
  const propertytype = useSelector(
    (store: any) => store?.filterReducer?.propertytype
  );

  const propertysubtype = useSelector(
    (store: any) => store?.filterReducer?.propertysubtype
  );
  const specialFeature = useSelector(
    (store: any) => store?.filterReducer?.specialFeature
  );
  const sorting = useSelector((store: any) => store?.filterReducer?.sorting);
  const locationParams = useSelector(
    (store: any) => store?.filterReducer?.locationParams
  );
  const pageNo = useSelector((store: any) => store?.filterReducer?.pageNo);
  const pageSize = useSelector((store: any) => store?.filterReducer?.pageSize);
  const toggleFilter = useSelector(
    (store: any) => store?.filterReducer?.toggleFilter
  );

  const clearFilter = useSelector(
    (store: any) => store?.filterReducer?.clearFilter
  );

  const checkAny = () => {
    if (
      !propertytype.includes("Residential") &&
      !propertysubtype.includes("Townhouse") &&
      !propertysubtype.includes("Condominium") &&
      !propertysubtype.includes("Villa/Patio Home") &&
      !specialFeature?.luxury &&
      !propertysubtype.includes("Multi Family") &&
      !propertytype.includes("Land") &&
      !specialFeature?.waterfront &&
      !specialFeature?.pool_Access &&
      !specialFeature?.horse_Permitted &&
      !specialFeature?.golf_Course &&
      !propertysubtype.includes("Farm")
    ) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    (async function () {
      setLoading(true);
      setLoadingForProType(true);
      let listing: any = await propertyListing({
        ...modalFilter,
        propertytype,
        propertysubtype,
        ...specialFeature,
        ...sorting,
        ...locationParams,
        pageNo,
        pageSize,
      });
      setoddata(listing?.odatacount);
      setPropertyListing(listing?.value);
      setLoading(false);
      setLoadingForProType(false);
    })();
  }, [toggleFilter, clearFilter]);

  // vs navigation menu with dynamic rendering

  const [activeNavItem, setActiveNavItem] = useState<string | null>(null);

  // Sync active nav item with filters (called on mount/filter change to sync UI)
  useEffect(() => {
    // Determine active nav item based on current filters in redux state
    if (propertytype.includes("Land")) {
      setActiveNavItem("Land For Sale");
    } else if (specialFeature?.newconstructionyn) {
      setActiveNavItem("New Construction For Sale");
    } else if (propertysubtype.includes("Townhouse")) {
      setActiveNavItem("Townhomes For Sale");
    } else if (propertysubtype.includes("Condominium")) {
      setActiveNavItem("Condos For Sale");
    } else if (propertytype.includes("Residential")) {
      setActiveNavItem("Homes For Sale");
    } else {
      setActiveNavItem(null);
    }
  }, [propertytype, propertysubtype, specialFeature]);

  // Handler for top nav item click - update filters, active nav and route
  const handleNavItemClick = (label: string) => {
    setActiveNavItem(label);
    dispatch(resetPageNo()); // Reset pagination
    console.log("label", label);
    // Clear irrelevant filters before setting property type/subtype
    dispatch(changePropertyType(""));
    dispatch(changeSubPropertyType(""));
    dispatch(
      changeSpecialFeature({
        newconstructionyn: null,
      })
    );

    switch (label) {
      case "Homes For Sale":
        dispatch(resetPageNo());
        dispatch(changePropertyType("Residential"));
        dispatch(changeSubPropertyType(""));
        dispatch(onToggleFilter());
        break;
      case "Townhomes For Sale":
        dispatch(resetPageNo());
        dispatch(changePropertyType("Residential"));
        dispatch(changeSubPropertyType("Townhouse"));
        dispatch(onToggleFilter());
        break;
      case "Condos For Sale":
        dispatch(resetPageNo());
        dispatch(changePropertyType("Residential"));
        dispatch(changeSubPropertyType("Condominium"));
        dispatch(onToggleFilter());
        break;
      case "Land For Sale":
        dispatch(resetPageNo());
        dispatch(changePropertyType("Land"));
        dispatch(changeSubPropertyType(""));
        dispatch(onToggleFilter());
        break;
      case "New Construction For Sale":
        dispatch(resetPageNo());
        dispatch(changePropertyType("Residential"));
        dispatch(changeSpecialFeature({ newconstructionyn: true }));
        dispatch(onToggleFilter());
        break;
      case "All Homes For Sale":
        dispatch(resetPageNo());
        dispatch(changeToAny());
        dispatch(onToggleFilter());
        break;
      default:
        break;
    }

    // Navigate to property-list route if not there already
    if (location.pathname !== "/property-list") {
      history.push("/property-list");
    }
  };

  const navItems = [
    {
      title: "Buy",
      isActive: false,

      dropdownItems: [
        {
          items: [
            {
              label: "Homes For Sale",
              // path: "/buy/houses-for-sale/",
              isActive: activeNavItem === "Homes For Sale",
              onClick: () => handleNavItemClick("Homes For Sale"),
            },
            {
              label: "Townhomes For Sale",
              // path: "/buy/townhouses-for-sale/",
              isActive: activeNavItem === "Townhomes For Sale",
              onClick: () => handleNavItemClick("Townhomes For Sale"),
            },
            {
              label: "Condos For Sale",
              // path: "/buy/condos-for-sale/",
              isActive: activeNavItem === "Condos For Sale",
              onClick: () => handleNavItemClick("Condos For Sale"),
            },
            {
              label: "Land For Sale",
              // path: "/buy/land-for-sale/",
              isActive: activeNavItem === "Land For Sale",
              onClick: () => handleNavItemClick("Land For Sale"),
            },
            {
              label: "New Construction For Sale",
              // path: "/buy/new-construction-for-sale/",
              isActive: activeNavItem === "New Construction For Sale",
              onClick: () => handleNavItemClick("New Construction For Sale"),
            },
            {
              label: "All Homes For Sale",
              // path: "/buy/all-homes-for-sale/",
              isActive: activeNavItem === "All Homes For Sale",
              onClick: () => handleNavItemClick("All Homes For Sale"),
            },
          ],
        },
        {
          items: [
            {
              label: "Buy With Milford",
              path: "/buy/buy-with-milford/",
              isActive: false,
            },
            {
              label: "Private Listings",
              path: "/buy/private-listings/",
              isActive: false,
            },
          ],
        },
        {
          items: [
            {
              label: "Buyer Guide",
              path: "/buy/buyer-guide/",
              isActive: false,
            },
            // {
            //   label: "Condo Guide",
            //   path: "/buy/condo-guide/",
            //   isActive: false,
            // },
          ],
        },
      ],
    },
    {
      title: "Sell",
      isActive: false,
      dropdownItems: [
        {
          items: [
            {
              label: "What Is My Home Worth?",
              path: "/sell/what-is-my-home-worth/",
              isActive: false,
            },
            {
              label: "Our Process",
              path: "/sell/our-process/",
              isActive: false,
            },
          ],
        },
        {
          items: [
            {
              label: "Sell With Milford",
              path: "/sell/sell-with-milford",
              isActive: false,
            },
          ],
        },
        {
          items: [
            {
              label: "Seller Guide",
              path: "/sell/seller-guide/",
              isActive: false,
            },
          ],
        },
      ],
    },
    // {
    //   title: "Mortgage",
    // },
  ];

  const localNavItems = [
    // { title: "Food + Drink", path: "/local/food-drink", isActive: false },
    // { title: "Arts + Culture", path: "/local/arts-culture", isActive: false },
    // { title: "Home + Design", path: "/local/home-design", isActive: false },
    // { title: "Retail + More", path: "/local/retail-more", isActive: false },
    // {
    //   title: "Hotel + Experiences",
    //   path: "/local/hotel-experiences",
    //   isActive: false,
    // },
    // { title: "Non-Profit", path: "/local/nonprofit", isActive: false },
    // {
    //   title: "Business Directory",
    //   path: "/local/business/directory",
    //   isActive: false,
    // },
  ];

  const navTabs = [
    {
      title: "LOCAL",

      path: "/local",
      content: <Navigation navItems={localNavItems} />,
    },
    {
      title: "MAGAZINE",

      path: "/magazine",
      content: null,
    },
    {
      title: "REAL ESTATE",

      path: "/homepage",
      content: <Navigation navItems={navItems} />,
    },
  ];


  return (
    <>
      <div
        className={
          location.pathname == "/property-list"
            ? "nav-wrapper-sticky nav-wrapper vs_newHeader"
            : "nav-wrapper vs_newHeader"
        }
      >
        <div className="nav-container ">
          <div className="navbarLogo d-flex">
            <Link to="/local">
              <img src={Logo} height="80" width="auto" alt="Logo" />
            </Link>
            <div className="mapIcon">
              <img src={mapIcon} alt="" />
              <p>Omaha, NE</p>
            </div>
          </div>

          {location.pathname.startsWith("/local") ||
            location.pathname.startsWith("/magazine") ? (
            ""
          ) : (
            <Filter
              filters={props?.filter}
              filterlist={filterlist}
              propertylisting={propertylisting}
              toggle={toggle}
              setToggle={setToggle}
              filter={filter}
              setFilter={setFilter}
              loading={loading}
              propertyTypeVal={propertyTypeVal}
              setPropertyTypeVal={setPropertyTypeVal}
              handleOnSearch={handleOnSearch}
              setCityAddress={setCityAddress}
              address={address}
              setAddress={setAddress}
            />
          )}

          {/* <Filter
            filters={props?.filter}
            filterlist={filterlist}
            propertylisting={propertylisting}
            toggle={toggle}
            setToggle={setToggle}
            filter={filter}
            setFilter={setFilter}
            loading={loading}
            propertyTypeVal={propertyTypeVal}
            setPropertyTypeVal={setPropertyTypeVal}
            handleOnSearch={handleOnSearch}
            setCityAddress={setCityAddress}
            address={address}
            setAddress={setAddress}
          /> */}

          {location.pathname.startsWith("/local") ||
            location.pathname.startsWith("/magazine") ? (
            ""
          ) : loggedin === false ? (
            <button
              onClick={handlelogin}
              className={`btn btn-login signupbtn loginbtn-top desktopview ml-3 ${location.pathname.startsWith("/local") ? "d-none " : ""
                }`}
            >
              <Link to="/login">Login</Link>
            </button>
          ) : (
            <div className="nav-heart-user ">
              <div className="nav-heart">
                <Link to="/property-list/favourites">
                  <i className="fa-solid fa-heart link-dark"></i>
                </Link>
              </div>

              <div className="profile-dropdown">
                <div
                  className="nav-user profile-dropdown"
                  onClick={() => handlePopup()}
                >
                  <i className="fa-solid fa-user"></i>
                </div>
                {toggleNav === true ? (
                  <ul>
                    <li>
                      <Link to="/property-list/clientprofile">Profile</Link>
                    </li>
                    <li>
                      <Link
                        to={{
                          pathname: "/leads",
                          state: { prevPath: location.pathname },
                        }}
                        onClick={gotoleads}
                      >

                        Dashboard
                      </Link>
                    </li>

                    <li>
                      <Link to="/property-list/favourites">Favorites</Link>
                    </li>
                    <li>
                      <Link to="/property-list/dislike">Dislikes</Link>
                    </li>
                    <li>
                      <Link to="/property-list/recentlyviewed">
                        Recently Viewed
                      </Link>
                    </li>
                    {/* <li>
                      <Link to="/property-list/yourteam">Your Team</Link>
                    </li> */}
                    <li>
                      <Link to="/property-list/account">Account Settings</Link>
                    </li>
                    <hr />
                    <li onClick={handleLogout}>
                      <Link className="btn sign-out-btn" to="/login">
                        SIGN OUT
                      </Link>
                    </li>
                  </ul>
                ) : (
                  ""
                )}
              </div>
            </div>
          )}
        </div>

        <div className="main-pages-links">
          <div className="links-section d-flex align-items-center justify-content-center w-100">
            <SwitchTab
              defaultActiveIndex={0}
              tabs={navTabs}
              navClass={"vs-nav"}
              navItemClass={"active"}
              tabContentClass={"vs-navtab"}
              containerClass={"mini-nav homepage-nav w-100"}

            />
          </div>
        </div>
      </div>

      {location.pathname == "/property-list" ? (
        <ul
          className={
            location.pathname == "/property-list"
              ? "search-quick-filter-sticky search-quick-filter"
              : "search-quick-filter"
          }
        >
          <li
            className={checkAny() ? "nevfilteractive" : ""}
            onClick={() => {
              // handlePropertyTypeChange(null)
              dispatch(resetPageNo());
              dispatch(changeToAny());
              dispatch(onToggleFilter());
            }}
          >
            <a href="#.">Any</a>
            <img src={any} />
          </li>
          <li
            className={
              propertytype.includes("Residential") ? "nevfilteractive" : ""
            }
            onClick={() => {
              // handlePropertyTypeChange("House")
              dispatch(resetPageNo());
              dispatch(changePropertyType("Residential"));
              dispatch(onToggleFilter());
            }}
          >
            <a href="#.">House</a>
            <img src={house} />
          </li>
          <li
            className={
              propertysubtype.includes("Townhouse") ? "nevfilteractive" : ""
            }
            onClick={() => {
              // handlePropertyTypeChange("Townhouse")
              dispatch(resetPageNo());
              dispatch(changeSubPropertyType("Townhouse"));
              dispatch(onToggleFilter());
            }}
          >
            {" "}
            <a href="#.">Townhouse</a>
            <img src={Townhouse} />
          </li>
          <li
            className={
              propertysubtype.includes("Condominium") ? "nevfilteractive" : ""
            }
            onClick={() => {
              // handlePropertyTypeChange("Condominium")
              dispatch(resetPageNo());
              dispatch(changeSubPropertyType("Condominium"));
              dispatch(onToggleFilter());
            }}
          >
            {" "}
            <a href="#.">Condo</a>
            <img src={Condo} />
          </li>
          <li
            className={
              propertysubtype.includes("Villa/Patio Home")
                ? "nevfilteractive"
                : ""
            }
            onClick={() => {
              // handlePropertyTypeChange("Villa/Patio Home")
              dispatch(resetPageNo());
              dispatch(changeSubPropertyType("Villa/Patio Home"));
              dispatch(onToggleFilter());
            }}
          >
            {" "}
            <a href="#.">Villa</a>
            <img src={Villa} />
          </li>
          <li
            className={specialFeature?.luxury ? "nevfilteractive" : ""}
            onClick={() => {
              // handlePropertyTypeChange("Luxury")
              dispatch(resetPageNo());
              dispatch(
                changeSpecialFeature({
                  luxury: specialFeature?.luxury ? null : true,
                })
              );
              dispatch(onToggleFilter());
            }}
          >
            {" "}
            <a href="#.">Luxury</a>
            <img src={Luxury} />
          </li>
          <li
            className={
              propertysubtype.includes("Multi Family") ? "nevfilteractive" : ""
            }
            onClick={() => {
              // handlePropertyTypeChange("Multi Family")
              dispatch(resetPageNo());
              dispatch(changeSubPropertyType("Multi Family"));
              dispatch(onToggleFilter());
            }}
          >
            {" "}
            <a href="#.">Multi-Family</a>
            <img src={MultiFamily} />
          </li>
          <li
            className={propertytype.includes("Land") ? "nevfilteractive" : ""}
            onClick={() => {
              // handlePropertyTypeChange("Land")
              dispatch(resetPageNo());
              dispatch(changePropertyType("Land"));
              dispatch(onToggleFilter());
            }}
          >
            {" "}
            <a href="#.">Land</a>
            <img src={Land} />
          </li>
          <li
            className={specialFeature?.waterfront ? "nevfilteractive" : ""}
            onClick={() => {
              // handlePropertyTypeChange("Waterfront")
              dispatch(resetPageNo());
              dispatch(
                changeSpecialFeature({
                  waterfront: specialFeature?.waterfront ? null : true,
                })
              );
              dispatch(onToggleFilter());
            }}
          >
            {" "}
            <a href="#.">Waterfront</a>
            <img src={Waterfront} />
          </li>
          <li
            className={specialFeature?.pool_Access ? "nevfilteractive" : ""}
            onClick={() => {
              // handlePropertyTypeChange("Pool_Access")
              dispatch(resetPageNo());
              dispatch(
                changeSpecialFeature({
                  pool_Access: specialFeature?.pool_Access ? null : true,
                })
              );
              dispatch(onToggleFilter());
            }}
          >
            {" "}
            <a href="#.">Pool</a>
            <img src={Pool} />
          </li>
          <li
            className={specialFeature?.horse_Permitted ? "nevfilteractive" : ""}
            onClick={() => {
              // handlePropertyTypeChange("Equestrian")
              dispatch(resetPageNo());
              dispatch(
                changeSpecialFeature({
                  horse_Permitted: specialFeature?.horse_Permitted
                    ? null
                    : true,
                })
              );
              dispatch(onToggleFilter());
            }}
          >
            {" "}
            <a href="#.">Equestrian</a>
            <img src={Equestrian} />
          </li>
          <li
            className={specialFeature?.golf_Course ? "nevfilteractive" : ""}
            onClick={() => {
              // handlePropertyTypeChange("Golf_Course")
              dispatch(resetPageNo());
              dispatch(
                changeSpecialFeature({
                  golf_Course: specialFeature?.golf_Course ? null : true,
                })
              );
              dispatch(onToggleFilter());
            }}
          >
            {" "}
            <a href="#.">Golfcourse</a>
            <img src={Golfcourse} />
          </li>
          <li
            className={
              propertysubtype.includes("Farm") ? "nevfilteractive" : ""
            }
            onClick={() => {
              // handlePropertyTypeChange("Farm")
              dispatch(resetPageNo());
              dispatch(changeSubPropertyType("Farm"));
              dispatch(onToggleFilter());
            }}
          >
            {" "}
            <a href="#.">Farms</a>
            <img src={forms} />
          </li>
        </ul>
      ) : (
        ""
      )}

      {location.pathname == "/property-list" ? (
        <>
          <NewProductDetails
            oddata={oddata}
            count={count}
            propertylisting={propertylisting}
            handleSorting={handleSorting}
            loading={loading}
            currentPage={currentPage}
            prevPage={prevPage}
            nextPage={nextPage}
            pagescountstartend={pagescountstartend}
            cityDetailsData={cityDetailsData?.current}
            handleOnSearch={handleOnSearch}
            setAddress={setAddress}
            filter={filter}
            setFilter={setFilter}
            selectedSort={selectedSort}
            setSelectedSort={setSelectedSort}
            handlePropertyTypeChange={handlePropertyTypeChange}
            loadingForProType={loadingForProType}
          />
        </>
      ) : (
        ""
      )}
    </>
  );
};
